export default {
  app: {
    tradeOffers: {
      country: 'País',
      loginPrompt: 'Para ver ofertas comerciais exclusivas, você precisa {0}.',
      logIn: 'login',
    },
  },
};
